module.exports = __webpack_public_path__ + "static/lauralaurentiu-f68d5206fd97a0de2c130ca5b0d9e7b3.png";